
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "./locales";

i18n
    .use(initReactI18next)
    .init({
        resources,
        debug: false,
        partialBundledLanguages: true,
        react: {
            wait: true,
            useSuspense: false,
            bindI18nStore: false,
            bindI18n: "languageChanged",
        },
    })
    .catch((err) => console.warn("Translation init error:", err));

i18n.on("loaded", function(loaded) {
    // noop
    // i18n has event callbacks for various phases of translations lifecycle.
    // In case some extra processing is required after a certain action
    // DOCS https://www.i18next.com/overview/api#events
});

export function changeLanguage(lang) {
    if (!lang) {
        throw new Error("Please provide language");
    }
    try {
        /**
         * changeLanguage will fetch the language from the server in case language
         * is not loaded
         */
        i18n.changeLanguage(lang);
        // Do something after language change?
    } catch (e) {
        console.log(e.message);
    }
}
export default i18n;
